import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormikField } from '../../Formik'
import { InputField } from '../../Input'
import {
  LISTING_FORM_DEPOSIT_TEXT_MAX_LENGTH,
  LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT,
} from '../RentalPortalListing.constants'

function RentalPortalListingDepositTextField({ isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormDepositTextLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={LISTING_FORM_DEPOSIT_TEXT_MAX_LENGTH}
      name={LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT}
      placeholder={t('RentalPortal.ListingFormDepositTextPlaceholderKey')}
    />
  )
}

export default RentalPortalListingDepositTextField
